$('.js-scroll-below').on('click', function ScrollBelow(e) {
    e.preventDefault();

    const $this = $(this);
    const $main = $('html, body');
    const $elScrollTo = $('.' + $this.data('scroll-to'));
    const top = $elScrollTo.offset().top - 33;
    const topMob = $elScrollTo.offset().top - 93;

    if($(window).width() >= '768') {
        $main.animate({
            scrollTop: top
        }, 1000);
    }else {
        $main.animate({
            scrollTop: topMob
        }, 1000);
    }
});
